import * as React from "react";
import {Col, Form, Input, Row, Select} from "antd";
import {FormattedMessage} from "react-intl";
import {createRequest, updateRequest, fetchItemRequest} from "@actions/alias";
import {Alias, AliasTypeOptions, AliasType} from "@models/alias";
import {Person} from "@models/person";
import {PersonRole} from "@models/person-role";
import withFormWrapper from "../../hocs/withFormWrapper";
import {SelectionMode} from "@models/index";
import PersonSelection from "@components/people/Selection";
import PersonRoleSelection from "../person-roles/PersonRoleSelection";

const {Option} = Select;

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  alias?: Alias,
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type AliasFormAllProps = PropsFromState & PropsFromDispatch


type AliasFormStateShape = {
  visible: boolean;
  text: string;
  reference_id: string | null;
  reference: Person | PersonRole | null
  type: AliasType;
  id: string | null;
};

class AliasForm extends React.Component<AliasFormAllProps, AliasFormStateShape> {
  constructor(props) {
    super(props);
    const {alias} = props;
    this.state = {
      visible: false,
      ...this.getStateFormProps(alias)
    };
  }
  
  getStateFormProps = (alias: Alias | null) => {
    const obj = alias || {};
    return {
      text: obj.text || "",
      id: obj.id,
      type: obj.type,
      reference_id: obj.reference_id,
      reference: obj.reference
    };
  };
  
  componentDidUpdate(prevProps, prevState) {
    if (this.props.alias && !prevProps.alias.is_fetched && this.props.alias.is_fetched) {
      this.setState({
        ...this.getStateFormProps(this.props.alias)
      })
    }
  }
  
  
  getValues = () => {
    let returnValues = null;
    this.props.form.setFieldsValue({
      'reference_id': this.state.reference ? this.state.reference.id : null
    });
    
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        
        returnValues = {
          ...values
        };
      }
    });
    
    return {
      payload: returnValues,
      id: this.state.id
    }
  };
  
  onChangeType = (type) => {
    this.setState({
      type: type,
      reference: null
    })
    this.props.form.setFieldsValue({
      type: type,
      reference: null
    });
  }
  onSelectReference = (reference: Person | PersonRole) => {
    this.setState({
      reference_id: reference.id,
      reference: reference
    })
    this.props.form.setFieldsValue({
      reference_id: reference.id,
      reference: reference
    });
  };
  
  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form>
        <Row>
          <Col span={24}>
            <Form.Item
              label={
                <FormattedMessage id="app.name" defaultMessage={`Name`}/>
              }
            >
              {getFieldDecorator("text", {
                initialValue: this.state.text,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.name_is_required"
                        defaultMessage={`Text is required`}
                      />
                    )
                  }
                ]
              })(<Input/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.type"
                  defaultMessage={`Type`}
                />
              }
            >
              {getFieldDecorator("type", {
                initialValue: this.state.type ? this.state.type : null,
                rules: [
                  {
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.type_is_required"
                        defaultMessage={`Type is required`}
                      />
                    )
                  }
                ]
              })(<Input type={`hidden`}/>)}
              <Select onChange={this.onChangeType} value={this.state.type}>
                {AliasTypeOptions.map((opt, index) => (
                  <Option key={index} value={opt.value}>{opt.label}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label={<FormattedMessage id="app.reference" defaultMessage={`Reference`}/>}>
              {getFieldDecorator("reference_id", {
                initialValue: this.state.reference_id ? this.state.reference_id : this.state.reference ? this.state.reference.id : null,
                rules: [
                  {
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.reference_is_required"
                        defaultMessage={`Reference is required!`}
                      />
                    )
                  }
                ]
              })(<Input type={`hidden`}/>)}
              {
                this.state.type === 'person' ? (
                  <PersonSelection
                    selectedPerson={this.state.reference}
                    mode={SelectionMode.DEFAULT}
                    disabled={this.state.type ? false : true}
                    onChange={this.onSelectReference}/>
                ) : (
                  <PersonRoleSelection
                    selectedPersonRole={this.state.reference}
                    mode={SelectionMode.DEFAULT}
                    disabled={this.state.type ? false : true}
                    onChange={this.onSelectReference}/>
                )
              }
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

const WrappedAliasForm = Form.create({name: "alias-form"})(AliasForm);

export default withFormWrapper(WrappedAliasForm);
